import { useState, useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import TranscriptForm from "./TranscriptForm";
import TranscriptPage from "./TranscriptPage";
import SignInPage from "./SignInPage";
import SignUpPage from "./SignUpPage";
import DashboardPage from "./DashboardPage";
import HubPagePublic from "./HubPagePublic";
import TermsPage from "./TermsPage";
import Header from "./components/Header";
import Footer from "./components/Footer";
import "./App.css";
import { getOrCreateVisitorId } from "./utils/visitor";

function AdminRedirect() {
  useEffect(() => {
    const backendOrigin =
      process.env.REACT_APP_BACKEND_ORIGIN || "http://127.0.0.1:8000";
    window.location.replace(`${backendOrigin}/admin/`);
  }, []);

  return null;
}

export default function App() {
  const [isDarkMode, setIsDarkMode] = useState(false);
  const [visitorId, setVisitorId] = useState(null);

  const toggleDarkMode = () => {
    setIsDarkMode(!isDarkMode);
  };

  // Initialize visitor ID on app load
  useEffect(() => {
    const id = getOrCreateVisitorId();
    setVisitorId(id);
  }, []);

  return (
    <BrowserRouter>
      <div className={isDarkMode ? "dark-mode" : "light-mode"}>
        <Header isDarkMode={isDarkMode} toggleDarkMode={toggleDarkMode} />
        <main style={{ minHeight: "calc(100vh - 180px)" }}>
          <Routes>
            {/* V5.2: Home/Create transcript at / */}
            <Route path="/" element={<TranscriptForm isDarkMode={isDarkMode} />} />
            
            {/* V5.2: Transcript page at /t/:youtubeId */}
            <Route path="/t/:youtubeId" element={<TranscriptPage isDarkMode={isDarkMode} visitorId={visitorId} />} />
            
            {/* Sign In and Sign Up pages */}
            <Route path="/signin" element={<SignInPage isDarkMode={isDarkMode} />} />
            <Route path="/signup" element={<SignUpPage isDarkMode={isDarkMode} />} />
            
            {/* Dashboard page */}
            <Route path="/dashboard" element={<DashboardPage isDarkMode={isDarkMode} />} />

            <Route path="/terms" element={<TermsPage isDarkMode={isDarkMode} />} />

            {/* Redirect admin route to Django admin */}
            <Route path="/admin/*" element={<AdminRedirect />} />
            
            {/* Hub page rendered in React app like other pages */}
            <Route path="/:hubSlug" element={<HubPagePublic isDarkMode={isDarkMode} />} />
          </Routes>
        </main>
        <Footer isDarkMode={isDarkMode} />
      </div>
    </BrowserRouter>
  );
}

